import type { TransactionResponseDto } from 'app/API/models';
import type { TransactionRow } from '../types/TransactionRow';

export const mapTransactionResponse = (transaction: TransactionResponseDto): TransactionRow => {
  const codeName = transaction.code?.name ?? 'charge';
  return {
    id: transaction.id,
    title: transaction.title,
    amount: transaction.amount,
    codeId: transaction.codeId,
    description: transaction.description ?? '',
    stripeChargeId: transaction.stripeChargeId ?? null,
    stripeReceiptUrl: transaction.stripeReceiptUrl ?? null,
    jobId: transaction.jobId ?? null,
    balanceId: transaction.balanceId,
    createdAt: transaction.createdAt,
    organization: undefined,
    code: {
      code: transaction.code?.name ?? transaction.codeId,
      status: codeName,
    },
  };
};
